import { render, staticRenderFns } from "./QuickReference.vue?vue&type=template&id=2ab0b68c"
import script from "./QuickReference.vue?vue&type=script&lang=js"
export * from "./QuickReference.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports